import gql from 'graphql-tag';
export const SchoolFragmentDoc = gql`
    fragment School on School {
  id
  slug
  isIndependent
  location {
    suburb {
      name
      formattedName
      state
    }
    state
    postCode
    coordinates
  }
  name
  type
  searchableName
  sector
  url
}
    `;
export const EventFragmentDoc = gql`
    fragment Event on Event {
  id
  shortId
  title
  status
  sessionDetails
  gettingThere
  parking
  capacity {
    availableSeats
    totalRegistrations
    remainingSeats
  }
  schools {
    ...School
  }
  hostSchool {
    ...School
  }
  date {
    start
    start_tz
    end
    end_tz
  }
}
    ${SchoolFragmentDoc}`;
export const GoodQuestionFragmentDoc = gql`
    fragment GoodQuestion on GoodQuestion {
  id
  question
  answer
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on Link {
  label
  url {
    ... on ExternalUrlBlock {
      id
      blockType
      url
    }
    ... on InternalUrlBlock {
      id
      blockType
      uri
    }
  }
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  id
  description
  width
  height
  url
  sizes {
    sm {
      url
      width
    }
    md {
      url
      width
    }
    lg {
      url
      width
    }
    xl {
      url
      width
    }
    xxl {
      url
      width
    }
    opengraph {
      url
      width
    }
  }
}
    `;
export const NewsArticleFragmentDoc = gql`
    fragment NewsArticle on NewsArticle {
  articleLink
  id
  publicationLogo {
    ...Image
  }
  publishedAt
  title
}
    ${ImageFragmentDoc}`;
export const PageFragmentDoc = gql`
    fragment Page on Page {
  id
  meta {
    description
    image {
      ...Image
    }
    title
  }
  template
}
    ${ImageFragmentDoc}`;
export const ResourceArticleFragmentDoc = gql`
    fragment ResourceArticle on ResourceArticle {
  category {
    id
    name
    slug
    showDate
    backgroundImageName
  }
  content
  id
  image {
    ...Image
  }
  meta {
    description
    image {
      ...Image
    }
    title
  }
  publishedAt
  slug
  title
}
    ${ImageFragmentDoc}`;
export const ResourceArticleCategoryFragmentDoc = gql`
    fragment ResourceArticleCategory on ResourceArticleCategory {
  id
  name
  slug
  subtitle
  showDate
  backgroundImageName
  topSectionColor
}
    `;
export const SuburbFragmentDoc = gql`
    fragment Suburb on Suburb {
  id
  formattedName
}
    `;
export const SupporterFragmentDoc = gql`
    fragment Supporter on Supporter {
  id
  image {
    ...Image
  }
  name
  quote
  role
}
    ${ImageFragmentDoc}`;
export const CreateEventRequestDocument = gql`
    mutation CreateEventRequest($data: mutationEventRequestInput!) {
  createEventRequest(data: $data) {
    id
  }
}
    `;
export const CreateNewsletterSignupDocument = gql`
    mutation CreateNewsletterSignup($data: mutationNewsletterSignupInput!) {
  createNewsletterSignup(data: $data) {
    id
  }
}
    `;
export const CreateParentDocument = gql`
    mutation CreateParent($data: mutationParentInput!) {
  createParent(data: $data) {
    id
  }
}
    `;
export const CreateStudentDocument = gql`
    mutation CreateStudent($data: mutationStudentInput!) {
  createStudent(data: $data) {
    id
    graduationYear
    school {
      id
    }
  }
}
    `;
export const DeletePledgeAccountDocument = gql`
    mutation DeletePledgeAccount($token: String!) {
  DeletePledgeAccount(token: $token) {
    success
  }
}
    `;
export const RequestExistingCommitmentLinkDocument = gql`
    mutation RequestExistingCommitmentLink($emails: [String!]!, $turnstileToken: String, $commitmentLinkToken: String) {
  RequestExistingCommitmentLink(
    emails: $emails
    turnstileToken: $turnstileToken
    commitmentLinkToken: $commitmentLinkToken
  ) {
    success
    reason
    linkSent
  }
}
    `;
export const RequestPledgeLinkDocument = gql`
    mutation RequestPledgeLink($email: String!, $turnstileToken: String) {
  RequestPledgeLink(email: $email, turnstileToken: $turnstileToken) {
    success
  }
}
    `;
export const UpdateEmailPreferencesDocument = gql`
    mutation UpdateEmailPreferences($id: String!, $signature: String, $email: String, $source: EmailSource!, $commitmentDigest: CommitmentDigest, $commitmentReminderOptOut: Boolean, $milestoneOptOut: Boolean, $groupOptOut: Boolean, $eventUpdatesOptOut: Boolean, $newsletterOptOut: Boolean) {
  UpdateEmailPreferences(
    id: $id
    signature: $signature
    email: $email
    source: $source
    commitmentDigest: $commitmentDigest
    commitmentReminderOptOut: $commitmentReminderOptOut
    milestoneOptOut: $milestoneOptOut
    groupOptOut: $groupOptOut
    eventUpdatesOptOut: $eventUpdatesOptOut
    newsletterOptOut: $newsletterOptOut
  ) {
    isParent
    isEventRegistrant
    commitmentDigest
    commitmentReminderOptOut
    milestoneOptOut
    groupOptOut
    eventUpdatesOptOut
    newsletterOptOut
  }
}
    `;
export const UpdatePledgeAccountDocument = gql`
    mutation UpdatePledgeAccount($token: String!, $firstName: String, $phone: String, $parents: [PledgeParentInput], $children: [PledgeChildInput]) {
  UpdatePledgeAccount(
    token: $token
    firstName: $firstName
    phone: $phone
    parents: $parents
    children: $children
  ) {
    firstName
    email
    phone
    parents {
      id
      firstName
      email
      phone
    }
    children {
      id
      firstName
      lastName
      finalPledgeYear
      graduationYear
      school {
        id
        name
        type
        state
      }
      cohort {
        id
        name
      }
      nextSchoolChangeAt
    }
  }
}
    `;
export const VerifyPledgeChallengeDocument = gql`
    mutation VerifyPledgeChallenge($turnstileToken: String, $commitmentLinkToken: String) {
  VerifyPledgeChallenge(
    turnstileToken: $turnstileToken
    commitmentLinkToken: $commitmentLinkToken
  ) {
    success
    reason
    token
  }
}
    `;
export const VerifyPledgeLinkDocument = gql`
    mutation VerifyPledgeLink($token: String!) {
  VerifyPledgeLink(token: $token) {
    token
    error
  }
}
    `;
export const GetAboutPageDocument = gql`
    query GetAboutPage {
  Pages(where: {template: {equals: About}}) {
    docs {
      ...Page
      aboutTemplateFields {
        header {
          heading
          image {
            ...Image
          }
        }
        intro {
          body
          supporterLogos {
            logo {
              ...Image
            }
          }
        }
        carousel {
          natureImage {
            ...Image
          }
          friendsImage {
            ...Image
          }
          hobbiesImage {
            ...Image
          }
        }
      }
    }
  }
}
    ${PageFragmentDoc}
${ImageFragmentDoc}`;
export const GetBuilderPageDocument = gql`
    query GetBuilderPage($slug: String) {
  BuilderPages(where: {_status: {equals: published}, slug: {equals: $slug}}) {
    docs {
      id
      title
      slug
      header {
        heading
        type
        image {
          ...Image
        }
      }
      content {
        ... on IntroTextBlock {
          blockType
          text
          showButton
          button {
            ...Link
          }
        }
        ... on RichTextBlock {
          blockType
          richText
        }
        ... on ImageCarouselBlock {
          blockType
          images {
            image {
              ...Image
            }
          }
        }
        ... on LogosBlock {
          blockType
          heading
          logos {
            logo {
              ...Image
            }
          }
        }
        ... on ResourceArticlesBlock {
          blockType
          heading
          showLatest
          selectedResourceArticles {
            ...ResourceArticle
          }
        }
        ... on DownloadsBlock {
          blockType
          heading
          downloads {
            title
            file {
              id
              url
            }
            image {
              ...Image
            }
          }
        }
        ... on YouTubeEmbedBlock {
          blockType
          videoId
        }
      }
    }
  }
}
    ${ImageFragmentDoc}
${LinkFragmentDoc}
${ResourceArticleFragmentDoc}`;
export const GetCohortMostCommonYearDocument = gql`
    query GetCohortMostCommonYear($schoolID: Int!, $graduationYear: Int!) {
  CohortMostCommonPledgeYear(schoolID: $schoolID, graduationYear: $graduationYear) {
    finalPledgeYear
  }
}
    `;
export const GetCohortStatsDocument = gql`
    query GetCohortStats($schoolID: Int!, $graduationYear: Int!) {
  CohortStats(schoolID: $schoolID, graduationYear: $graduationYear) {
    graduationYear
    school {
      ...School
      events(
        limit: 1
        sort: "date.start"
        where: {status: {in: [scheduled, upcoming]}}
      ) {
        docs {
          id
        }
      }
    }
    studentCount
  }
}
    ${SchoolFragmentDoc}`;
export const GetCommitmentLinkStatusDocument = gql`
    query GetCommitmentLinkStatus($token: String!) {
  CommitmentLinkStatus(token: $token) {
    valid
  }
}
    `;
export const GetDefaultSurveyDocument = gql`
    query GetDefaultSurvey {
  Surveys(where: {isDefault: {equals: true}}, limit: 1) {
    docs {
      id
      branded
      slug
      title
      url
    }
  }
}
    `;
export const GetEmailPreferencesDocument = gql`
    query GetEmailPreferences($id: String!, $signature: String, $email: String, $source: EmailSource!) {
  EmailPreferences(id: $id, signature: $signature, email: $email, source: $source) {
    isParent
    isEventRegistrant
    commitmentDigest
    commitmentReminderOptOut
    milestoneOptOut
    groupOptOut
    eventUpdatesOptOut
    newsletterOptOut
  }
}
    `;
export const GetEventByShortIdDocument = gql`
    query GetEventByShortId($shortId: String!) {
  Events(limit: 1, where: {shortId: {equals: $shortId}}) {
    docs {
      ...Event
      relatedEvents {
        ...Event
      }
    }
  }
}
    ${EventFragmentDoc}`;
export const GetGlobalsDocument = gql`
    query GetGlobals {
  Settings {
    meta {
      title
      description
      image {
        ...Image
      }
    }
    menu {
      items {
        label
        link {
          relationTo
          value {
            ... on BuilderPage {
              slug
            }
            ... on Page {
              uri
            }
            ... on StaticPage {
              slug
            }
          }
        }
        icons {
          icon
          color
          scale
          rotation
        }
      }
    }
    banner {
      isEnabled
      text
      backgroundColour
      textColour
      cta {
        label
        url
      }
    }
    pledge {
      cohortCard {
        heading {
          firstSignUp
          multipleSignUps
        }
        sharing {
          firstSignUp
          multipleSignUps
        }
      }
      heading
      nextSteps
      bringAnotherFamilyWithYou
    }
    schoolStatsPage {
      enableGlobalSchoolStats
    }
  }
  GlobalStats {
    pledges
    schools
  }
  LegalPages {
    termsOfUse {
      content
      updatedAt
    }
    privacyPolicy {
      content
      updatedAt
    }
  }
}
    ${ImageFragmentDoc}`;
export const GetGoodQuestionsDocument = gql`
    query GetGoodQuestions($limit: Int) {
  GoodQuestions(limit: $limit, sort: "_order") {
    docs {
      ...GoodQuestion
    }
  }
}
    ${GoodQuestionFragmentDoc}`;
export const GetHomePageDocument = gql`
    query GetHomePage {
  Pages(where: {template: {equals: Home}}) {
    docs {
      ...Page
      homeTemplateFields {
        header {
          showStats
        }
        intro {
          body
          ctaButton {
            ...Link
          }
          image {
            ...Image
          }
        }
        whySection {
          heading
          cards {
            heading
            largeText
            body
          }
          ctaButton {
            ...Link
          }
          carousel {
            image {
              ...Image
            }
          }
        }
        joinSection {
          heading
          body
          stepCards {
            icon
            heading
            body
          }
        }
      }
    }
  }
}
    ${PageFragmentDoc}
${LinkFragmentDoc}
${ImageFragmentDoc}`;
export const GetImageDocument = gql`
    query GetImage($id: String!) {
  Image(id: $id) {
    ...Image
  }
}
    ${ImageFragmentDoc}`;
export const GetNewsArticlesDocument = gql`
    query GetNewsArticles($limit: Int, $page: Int) {
  NewsArticles(limit: $limit, page: $page, sort: "-publishedAt") {
    docs {
      ...NewsArticle
    }
    page
    limit
    totalPages
  }
}
    ${NewsArticleFragmentDoc}`;
export const GetPageDocument = gql`
    query GetPage($template: Page_template_Input) {
  Pages(where: {template: {equals: $template}}) {
    docs {
      ...Page
      aboutFields {
        header {
          heading
          image {
            ...Image
          }
        }
        intro {
          body
          supporterLogos {
            logo {
              ...Image
            }
          }
        }
        carousel {
          natureImage {
            ...Image
          }
          friendsImage {
            ...Image
          }
          hobbiesImage {
            ...Image
          }
        }
      }
      homeFields {
        header {
          showStats
        }
        intro {
          body
          ctaButton {
            ...Link
          }
          image {
            ...Image
          }
        }
        whySection {
          heading
          cards {
            heading
            largeText
            body
          }
          ctaButton {
            ...Link
          }
          carousel {
            image {
              ...Image
            }
          }
        }
        joinSection {
          heading
          body
          stepCards {
            icon
            heading
            body
          }
        }
      }
      resourcesFields {
        filters {
          id
          name
        }
      }
      whyWaitFields {
        intro {
          body
        }
        cards {
          heading
          largeText
          body
        }
      }
    }
  }
}
    ${PageFragmentDoc}
${ImageFragmentDoc}
${LinkFragmentDoc}`;
export const GetPledgeAccountDocument = gql`
    query GetPledgeAccount($token: String!) {
  PledgeAccount(token: $token) {
    firstName
    email
    phone
    parents {
      id
      firstName
      email
      phone
    }
    children {
      id
      firstName
      lastName
      finalPledgeYear
      graduationYear
      school {
        id
        name
        type
        state
      }
      cohort {
        id
        name
      }
      nextSchoolChangeAt
    }
  }
}
    `;
export const GetResourceArticleBySlugDocument = gql`
    query GetResourceArticleBySlug($slug: String!) {
  ResourceArticles(where: {slug: {equals: $slug}, _status: {equals: published}}) {
    docs {
      ...ResourceArticle
    }
  }
}
    ${ResourceArticleFragmentDoc}`;
export const GetResourceArticlesDocument = gql`
    query GetResourceArticles($limit: Int, $page: Int, $categoryID: JSON) {
  ResourceArticles(
    limit: $limit
    page: $page
    sort: "-publishedAt"
    where: {category: {equals: $categoryID}, _status: {equals: published}}
  ) {
    docs {
      ...ResourceArticle
    }
    page
    limit
    totalPages
  }
}
    ${ResourceArticleFragmentDoc}`;
export const GetResourceArticlesByCategoriesDocument = gql`
    query GetResourceArticlesByCategories($limit: Int, $categoryIDs: [JSON]) {
  ResourceArticles(
    limit: $limit
    sort: "-publishedAt"
    where: {category: {in: $categoryIDs}, _status: {equals: published}}
  ) {
    docs {
      ...ResourceArticle
    }
  }
}
    ${ResourceArticleFragmentDoc}`;
export const GetResourceCategoriesDocument = gql`
    query GetResourceCategories {
  ResourceArticleCategories(sort: "name", limit: 100) {
    docs {
      ...ResourceArticleCategory
    }
  }
}
    ${ResourceArticleCategoryFragmentDoc}`;
export const GetResourceCategoryBySlugDocument = gql`
    query GetResourceCategoryBySlug($slug: String!) {
  ResourceArticleCategories(where: {slug: {equals: $slug}}, limit: 1) {
    docs {
      ...ResourceArticleCategory
    }
  }
}
    ${ResourceArticleCategoryFragmentDoc}`;
export const GetResourcesPageDocument = gql`
    query GetResourcesPage {
  Pages(where: {template: {equals: Resources}}) {
    docs {
      ...Page
      resourcesTemplateFields {
        filters {
          id
          name
        }
      }
    }
  }
}
    ${PageFragmentDoc}`;
export const GetSaMicrositePageDocument = gql`
    query GetSaMicrositePage {
  Pages(where: {template: {equals: SaMicrosite}}) {
    docs {
      ...Page
      saMicrositeTemplateFields {
        header {
          heading
          body
          youtubeVideoId
        }
        statisticsSection {
          heading
          body
          cards {
            heading
            stat
          }
        }
        premierSection {
          heading
          body
          letter
        }
        faqSection {
          heading
          items {
            question
            answer
          }
        }
      }
    }
  }
}
    ${PageFragmentDoc}`;
export const GetSaSchoolBySlugDocument = gql`
    query GetSaSchoolBySlug($slug: String!, $currentYear: Float!) {
  Schools(limit: 1, where: {slug: {equals: $slug}, location__state: {equals: SA}}) {
    docs {
      ...School
      themeColour
      cohorts(where: {graduationYear: {greater_than_equal: $currentYear}}) {
        docs {
          id
          graduationYear
          uniqueStudentCount
        }
      }
      events(sort: "date.start", where: {status: {in: [scheduled, upcoming]}}) {
        docs {
          ...Event
        }
      }
    }
  }
}
    ${SchoolFragmentDoc}
${EventFragmentDoc}`;
export const GetSaSchoolsSortedDocument = gql`
    query GetSaSchoolsSorted($limit: Int, $query: String!, $type: [School_type_Input]) {
  SchoolsSorted(
    query: $query
    limit: $limit
    where: {type: {in: $type}, location__state: {equals: SA}}
  ) {
    docs {
      ...School
    }
  }
}
    ${SchoolFragmentDoc}`;
export const GetSchoolDocument = gql`
    query GetSchool($id: Int!, $currentYear: Float!) {
  School(id: $id) {
    ...School
    enrolments {
      total
      byYearLevel
    }
    parentSchool {
      id
      name
      enrolments {
        total
        byYearLevel
      }
    }
    cohorts(where: {graduationYear: {greater_than_equal: $currentYear}}) {
      docs {
        id
        graduationYear
        uniqueStudentCount
      }
    }
  }
}
    ${SchoolFragmentDoc}`;
export const GetSchoolBySlugDocument = gql`
    query GetSchoolBySlug($slug: String!, $currentYear: Float!) {
  Schools(where: {slug: {equals: $slug}}) {
    docs {
      ...School
      hasCustomPage
      themeColour
      logo {
        ...Image
      }
      enrolments {
        total
        byYearLevel
      }
      parentSchool {
        id
        name
        enrolments {
          total
          byYearLevel
        }
      }
      cohorts(where: {graduationYear: {greater_than_equal: $currentYear}}) {
        docs {
          id
          graduationYear
          uniqueStudentCount
        }
      }
      events(
        limit: 1
        sort: "date.start"
        where: {status: {in: [scheduled, upcoming]}}
      ) {
        docs {
          id
        }
      }
    }
  }
}
    ${SchoolFragmentDoc}
${ImageFragmentDoc}`;
export const GetSchoolMapPointsDocument = gql`
    query GetSchoolMapPoints($currentYear: Int!) {
  SchoolMapPoints(currentYear: $currentYear) {
    id
    name
    slug
    coordinates
    state
    suburb
    sector
    type
    uniqueStudentCount
    isTrending
    isNew
    hasStrength
    primaryProgress
    pledgeYearCounts {
      year
      count
    }
  }
}
    `;
export const GetSchoolSaSessionDocument = gql`
    query GetSchoolSaSession($id: Int!) {
  Schools(limit: 1, where: {id: {equals: $id}}) {
    docs {
      id
      slug
      events(
        limit: 1
        sort: "date.start"
        where: {status: {in: [scheduled, upcoming]}}
      ) {
        docs {
          id
        }
      }
    }
  }
}
    `;
export const GetSchoolsDocument = gql`
    query GetSchools($limit: Int, $page: Int, $currentYear: Float!, $hasStrengthInNumbers: Boolean, $sectors: [School_sector_Input], $states: [School_location__state_Input], $suburbs: [JSON], $types: [School_type_Input]) {
  Schools(
    limit: $limit
    page: $page
    where: {hasStrengthInNumbers: {equals: $hasStrengthInNumbers}, sector: {in: $sectors}, location__state: {in: $states}, location__suburb: {in: $suburbs}, type: {in: $types}}
  ) {
    docs {
      ...School
      enrolments {
        total
        byYearLevel
      }
      parentSchool {
        id
        name
        enrolments {
          total
          byYearLevel
        }
      }
      cohorts(where: {graduationYear: {greater_than_equal: $currentYear}}) {
        docs {
          id
          graduationYear
          uniqueStudentCount
        }
      }
    }
    totalDocs
    page
    limit
    totalPages
  }
}
    ${SchoolFragmentDoc}`;
export const GetSchoolsSortedDocument = gql`
    query GetSchoolsSorted($limit: Int, $query: String!, $type: [School_type_Input]) {
  SchoolsSorted(query: $query, limit: $limit, where: {type: {in: $type}}) {
    docs {
      ...School
    }
  }
}
    ${SchoolFragmentDoc}`;
export const GetStaticPageDocument = gql`
    query GetStaticPage($slug: String!) {
  StaticPages(where: {slug: {equals: $slug}}) {
    docs {
      content
      id
      intro
      title
      updatedAt
    }
  }
}
    `;
export const GetStatsDocument = gql`
    query GetStats($hasStrengthInNumbers: Boolean, $sectors: [SchoolSector], $states: [SchoolState], $suburbs: [String], $types: [SchoolType]) {
  Stats(
    hasStrengthInNumbers: $hasStrengthInNumbers
    sectors: $sectors
    states: $states
    suburbs: $suburbs
    types: $types
  ) {
    cohorts
    strengthCohorts
    pledges
    schools
    totalSchools
    latestPledge {
      school
    }
  }
}
    `;
export const GetSuburbsSortedDocument = gql`
    query GetSuburbsSorted($limit: Int, $query: String!, $states: [Suburb_state_Input]) {
  SuburbsSorted(query: $query, limit: $limit, where: {state: {in: $states}}) {
    docs {
      ...Suburb
    }
  }
}
    ${SuburbFragmentDoc}`;
export const GetSupportersDocument = gql`
    query GetSupporters($limit: Int) {
  Supporters(limit: $limit, sort: "_order") {
    docs {
      ...Supporter
    }
  }
}
    ${SupporterFragmentDoc}`;
export const GetSurveyBySlugDocument = gql`
    query GetSurveyBySlug($slug: String!) {
  Surveys(where: {slug: {equals: $slug}}, limit: 1) {
    docs {
      id
      branded
      slug
      title
      url
    }
  }
}
    `;
export const GetWhyWaitPageDocument = gql`
    query GetWhyWaitPage {
  Pages(where: {template: {equals: WhyWait}}) {
    docs {
      ...Page
      whyWaitTemplateFields {
        intro {
          body
        }
        cards {
          heading
          largeText
          body
        }
      }
    }
  }
}
    ${PageFragmentDoc}`;